import styled from '@emotion/styled';
import {ReactComponent as CloseSVG} from '../../../assets/icons/ic_close.svg';
export const MobileSideBarContainer = styled.div<{isOpen: boolean}>`
  position: absolute;
  top: ${({theme}) => theme.margin.mobile.xl};
  right: 0;
  overflow: hidden;
  margin-right: ${({isOpen, theme}) => (isOpen ? theme.margin.mobile.xl : '0')};
  height: calc(100dvh - ${({theme}) => theme.margin.mobile.xl}*2);
  min-width: 240px;
  background-color: ${({theme}) => theme.color.surface.niv1};
  z-index: 999; /* Above the overlay */
  transform: ${({isOpen}) => (isOpen ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s ease-in-out;
  display: ${({isOpen}) => (isOpen ? 'flex' : 'none')};
  flex-direction: column;
  border-radius: ${({theme}) => theme.border.radius.md};
  box-shadow: ${({theme, isOpen}) =>
    isOpen ? theme.boxShadow.primary : 'none'};

  /* Landscape mode adjustments */
  @media screen and (orientation: landscape) {
    top: ${({theme}) => theme.margin.mobile.md};
    height: calc(100dvh - ${({theme}) => theme.margin.mobile.md}*2);
  }
`;

export const MobileTopSection = styled.div`
  padding: ${({theme}) =>
    `${theme.padding.mobile.lg} ${theme.padding.mobile.md}`};
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: ${({theme}) => theme.gap.mobile.sm};
  align-items: center;
`;

export const LenderInformation = styled.div`
  display: flex;
  align-items: center;
  gap: ${({theme}) => theme.gap.mobile.md};
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: ${({theme}) => theme.padding.mobile.xs};
`;

export const CloseIcon = styled(CloseSVG)`
  width: ${({theme}) => theme.icon.size.md};
  height: ${({theme}) => theme.icon.size.md};
  color: ${({theme}) => theme.color.black};
`;

export const MobileMenuContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  overflow-y: auto;
  flex-direction: column;
`;

export const MobileTopMenuSection = styled.div`
  padding: ${({theme}) => theme.padding.mobile.md} 0;
`;

export const MobileBottomMenuSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.mobile.lg};
  padding-bottom: ${({theme}) => theme.padding.mobile.lg};
`;

// Reuse other styled from SideBar-styles.ts
